// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  campaignId: __t.string(),
  nonce: __t.string(),
  epoch: __t.u64(),
  tick: __t.u64(),
  cursor: __t.u64(),
  stateJson: __t.string(),
  resultsJson: __t.string(),
  factionsJson: __t.string(),
  cityChangesJson: __t.string(),
  territoryJson: __t.string(),
};
